import { gangtokInstance as http } from "./http-common";

const token = JSON.parse(localStorage.getItem("token"));

const getHiredVehicleReports = (type) => {
  return http.post(`HireVechCountForSLG/GetHireVechCount?type=${type}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const SilliguriService = {
  getHiredVehicleReports,
};

export default SilliguriService;
